import { transition } from '@helpers/animate';
import brand, { textShadow } from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  position: relative;
  background: ${brand.greyDark};
  color: ${brand.white};
`;
const Video = styled.video `
  display: block;
  height: calc(9 / 16 * 100vw);
  object-fit: cover;
  object-position: center;
  pointer-events: none;
  width: 100%;
  position: relative;
`;
const ModalVideo = styled.video ``;
const Tint = styled.div `
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  background: ${brand.greyDark};
  height: 100%;
  opacity: var(--amount, 0);
  width: 100%;
`;
const TitleWrapper = styled.div `
  --overflow: ${fluid(85, 120, Device.Tablet)};

  position: absolute;
  top: calc(var(--overflow) * -1);
  left: 0;
  height: calc(100% + (var(--overflow) * 2));
  width: 100%;
  display: grid;
  place-content: center;
`;
const Title = styled.h1 `
  ${transition('color, filter')};

  position: sticky;
  top: var(--headerScrollHeight);
  display: block;
  color: currentColor;
  filter: ${textShadow};
  ${fonts.zahrah.medium};
  font-size: ${fluid(30, 62)};
  line-height: ${fluid(40, 72)};
  text-align: center;

  &[data-out-container='true'] {
    color: ${brand.black};
    filter: none;
  }

  @media ${until(Device.Tablet)} {
    display: none;
  }
`;
const Cta = styled.button `
  ${fonts.brandonGrotesque.bold};

  position: absolute;
  bottom: 24px;
  right: 24px;
  display: flex;
  align-items: center;
  background: none;
  border: 0;
  color: currentColor;
  filter: ${textShadow};
  font-size: ${fluid(18, 26)};
  line-height: 1em;
  margin: 0;
  padding: 0;
  text-align: center;
  text-decoration: none;
  text-underline-position: under;
  white-space: nowrap;

  svg {
    display: inline-block;
    height: ${fluid(24, 32)};
    margin-right: ${fluid(8, 16)};
    width: ${fluid(24, 32)};
  }

  &:focus,
  &:hover {
    text-decoration: underline;
  }
`;
const HomepageHeroBannerVideoStyles = {
    Container,
    Cta,
    ModalVideo,
    Tint,
    Title,
    Video,
    TitleWrapper,
};
export default HomepageHeroBannerVideoStyles;
